import React from "react";

const AuthorBox = ({ post }) => {
  const authorName = post?.author || "PrepNexis AI";
  const authorInitial = authorName.charAt(0).toUpperCase();

  return (
    <div className="mb-10 mt-6 rounded-md border border-slate-200 bg-white p-5 shadow-sm sm:p-6">
      <div className="flex flex-col gap-4 sm:flex-row">
        <a
          href={post?.authorLink || "/blog"}
          aria-label="Author profile"
          className="grid h-14 w-14 shrink-0 place-items-center rounded-sm bg-[rgba(126,34,206,0.08)] text-xl font-extrabold text-[rgb(126,34,206)] ring-1 ring-[rgba(126,34,206,0.16)]"
        >
          {authorInitial}
        </a>
        <div>
          <p className="text-sm font-semibold uppercase text-gray-500">
            Written by
          </p>
          <a
            href={post?.authorLink || "/blog"}
            className="mt-1 inline-block text-lg font-extrabold text-gray-900 hover:text-[rgb(126,34,206)]"
          >
            {authorName}
          </a>
          <p className="mt-2 leading-7 text-gray-600">
            PrepNexis is committed to your PTE success and excellence. Stay
            tuned for updates, expert advice, and the latest resources to
            elevate your PTE preparation journey.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AuthorBox;
